/* Scroll-reveal (theme carried over from Pro Stock North America).
   theme.liquid adds the 'psna-js' class to <html> inline before first
   paint; that class is what hides .psna-reveal elements, so without JS
   the page renders fully visible. Siblings that reveal together are
   staggered via the --psna-delay custom property read by psna-custom.css. */
(function () {
  var els = Array.prototype.slice.call(document.querySelectorAll('.psna-reveal'));
  if (!els.length) return;

  function reveal(el) {
    el.classList.add('psna-inview');
  }

  if (
    window.matchMedia('(prefers-reduced-motion: reduce)').matches ||
    !('IntersectionObserver' in window)
  ) {
    els.forEach(reveal);
    return;
  }

  var counts = new Map();
  els.forEach(function (el) {
    var i = counts.get(el.parentElement) || 0;
    el.style.setProperty('--psna-delay', Math.min(i * 70, 350) + 'ms');
    counts.set(el.parentElement, i + 1);
  });

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          reveal(entry.target);
          observer.unobserve(entry.target);
        }
      });
    },
    { rootMargin: '0px 0px -10% 0px' }
  );

  els.forEach(function (el) {
    observer.observe(el);
  });
})();

/* Hand preference chips for the restock alert form.
   Bridge: the section that should render these server-side is pending a
   GitHub-sync fix on Shopify's end, so build the same markup client-side.
   Idempotent - if the fieldset is already server-rendered, do nothing. */
(function () {
  var form = document.getElementById('psna-alert-form');
  if (!form || form.querySelector('.psna-hand-chips')) return;
  var tagsInput = form.querySelector('input[name="contact[tags]"]');
  if (!tagsInput) return;
  var baseTags = tagsInput.value;

  var fieldset = document.createElement('fieldset');
  fieldset.className = 'psna-hand-chips';
  fieldset.innerHTML =
    '<legend class="psna-hand-chips__label">Which hand do you shoot?</legend>' +
    '<label class="psna-hand-chip"><input type="radio" name="psna-hand" value="pref-hand-lh"><span>Left</span></label>' +
    '<label class="psna-hand-chip"><input type="radio" name="psna-hand" value="pref-hand-rh"><span>Right</span></label>' +
    '<label class="psna-hand-chip"><input type="radio" name="psna-hand" value="" checked><span>Both</span></label>';
  form.insertBefore(fieldset, form.firstChild);

  fieldset.addEventListener('change', function (evt) {
    if (evt.target.name !== 'psna-hand') return;
    tagsInput.value = evt.target.value ? baseTags + ', ' + evt.target.value : baseTags;
  });
})();

/* Bundle & Save.
   LIVE is the single launch switch for the whole feature: the product-page
   widget (snippets/psna-bundle-save.liquid, server-rendered hidden), the
   site-wide savings strip, and the cart-notification nudge. Flip it to true
   ONLY once the matching automatic discounts exist in Shopify admin —
   otherwise the site promises savings checkout won't apply. The dollar
   amounts here must agree with that snippet and those discounts.
   Preview without launching: append ?psna-preview=1 to any URL (sticky for
   the browser session; ?psna-preview=0 turns it off). */
(function () {
  var CFG = {
    LIVE: false, /* off: Ozzy's store has no matching bundle discounts */
    TIER2_OFF: 10, /* $ off the order at 2+ sticks — must match the admin discount */
    TIER3_OFF: 19, /* $ off the order at 3+ sticks — must match the admin discount */
    STICKS_URL: '/collections/prostock-sticks'
  };

  var params = new URLSearchParams(window.location.search);
  if (params.get('psna-preview') === '0') sessionStorage.removeItem('psnaPreview');
  else if (params.has('psna-preview')) sessionStorage.setItem('psnaPreview', '1');
  if (!CFG.LIVE && sessionStorage.getItem('psnaPreview') !== '1') return;

  /* ---- product page: reveal the widget, wire radios <-> quantity ---- */
  var widget = document.querySelector('[data-psna-bundle]');
  if (widget) {
    widget.hidden = false;
    var qtyInput = document.querySelector(
      'input[name="quantity"][form="' + widget.getAttribute('data-form-id') + '"]'
    );
    var radios = widget.querySelectorAll('input[name="psna-bundle-qty"]');

    function highlight() {
      Array.prototype.forEach.call(radios, function (r) {
        r.closest('.psna-bundle__opt').classList.toggle('is-selected', r.checked);
      });
    }

    widget.addEventListener('change', function (evt) {
      if (evt.target.name !== 'psna-bundle-qty') return;
      highlight();
      if (!qtyInput) return;
      qtyInput.value = evt.target.value;
      qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
    });

    /* Stepper still works for >3; mirror it back onto the cards. */
    if (qtyInput) {
      qtyInput.addEventListener('change', function () {
        var v = String(qtyInput.value);
        Array.prototype.forEach.call(radios, function (r) {
          r.checked = r.value === v;
        });
        highlight();
      });
    }
  }

  /* ---- cart state -> savings strip + cart-notification nudge ---- */
  function isStick(item) {
    /* product_type is only set on some sticks; every stick title carries
       "<n> Flex". Display heuristic only — the discounts themselves are
       scoped to the prostock-sticks collection in admin. */
    return item.product_type === 'Pro Stock Stick' || /\bflex\b/i.test(item.product_title || '');
  }

  /* Flat per-order amounts: the bigger tier simply replaces the smaller. */
  function savings(n) {
    return n >= 3 ? CFG.TIER3_OFF : CFG.TIER2_OFF;
  }

  function message(state) {
    if (!state || state.n === 0) return null;
    if (state.n === 1) {
      return {
        html: 'Add one more stick — <strong>$' + savings(2) + ' off</strong> at checkout. Any model counts.',
        cta: true
      };
    }
    var html = '<strong>$' + savings(state.n) + ' off</strong> applied at checkout';
    if (state.n === 2) html += ' — a 3rd stick makes it $' + CFG.TIER3_OFF + '.';
    return { html: html, cta: state.n === 2 };
  }

  var strip = null;
  function renderStrip(state) {
    var m = message(state);
    if (!m || sessionStorage.getItem('psnaStripHide') === '1') {
      if (strip) {
        strip.remove();
        strip = null;
        document.body.classList.remove('psna-strip-open');
      }
      return;
    }
    if (!strip) {
      strip = document.createElement('div');
      strip.className = 'psna-strip';
      strip.innerHTML =
        '<div class="psna-strip__inner">' +
        '<span class="psna-strip__msg"></span>' +
        '<a class="psna-strip__cta" href="' + CFG.STICKS_URL + '">Shop sticks →</a>' +
        '<button type="button" class="psna-strip__close" aria-label="Dismiss">&times;</button>' +
        '</div>';
      strip.querySelector('.psna-strip__close').addEventListener('click', function () {
        sessionStorage.setItem('psnaStripHide', '1');
        renderStrip(null);
      });
      document.body.appendChild(strip);
      document.body.classList.add('psna-strip-open');
    }
    strip.querySelector('.psna-strip__msg').innerHTML = m.html;
    strip.querySelector('.psna-strip__cta').hidden = !m.cta;
  }

  function renderNudge(state) {
    var notification = document.getElementById('cart-notification');
    if (!notification || !notification.classList.contains('active')) return;
    var links = notification.querySelector('.cart-notification__links');
    if (!links) return;
    var m = message(state);
    var nudge = notification.querySelector('.psna-nudge');
    if (!m) {
      if (nudge) nudge.remove();
      return;
    }
    if (!nudge) {
      nudge = document.createElement('p');
      nudge.className = 'psna-nudge';
      links.parentNode.insertBefore(nudge, links);
    }
    nudge.innerHTML = m.html;
  }

  var refreshTimer = null;
  var lastState = null;
  function refresh() {
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(function () {
      fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var n = 0;
          cart.items.forEach(function (item) {
            if (isStick(item)) n += item.quantity;
          });
          var state = { n: n, total: cart.total_price };
          lastState = state;
          renderStrip(state);
          renderNudge(state);
        })
        .catch(function () { /* strip is informational; stay quiet offline */ });
    }, 150);
  }

  /* The nudge used to arrive only after the /cart.js round-trip, which
     grew the popup mid-slide and read as a jerk. Render it from the
     last known cart state plus the quantity just added, synchronously
     on the popup's class flip, so it's in the first painted frame; the
     fetch corrects it a beat later (normally to identical text). */
  function optimisticNudge() {
    var notification = document.getElementById('cart-notification');
    if (!notification || !notification.classList.contains('active') || !lastState) return;
    var name = notification.querySelector('.cart-notification-product__name');
    if (!name || !/\bflex\b/i.test(name.textContent)) return;
    var qtyInput = document.querySelector('form[action*="/cart/add"] input[name="quantity"]');
    var qty = Math.max(1, parseInt(qtyInput && qtyInput.value, 10) || 1);
    renderNudge({ n: lastState.n + qty, total: lastState.total });
  }

  /* The theme re-renders #cart-icon-bubble on every cart mutation (add,
     change, remove — every surface), so observing it catches them all.
     The notification's class flip catches the post-add popup moment. */
  var bubble = document.getElementById('cart-icon-bubble');
  if (bubble) new MutationObserver(refresh).observe(bubble, { childList: true, subtree: true });
  var notification = document.getElementById('cart-notification');
  if (notification) {
    new MutationObserver(function () {
      optimisticNudge();
      refresh();
    }).observe(notification, { attributes: true, attributeFilter: ['class'] });
  }
  window.addEventListener('pageshow', refresh);
  refresh();
})();

/* Cart-notification polish.
   The popup's option rows (Shot/Flex/Curve) repeat what every stick
   title already says, but the YOU SAVE line-item property is worth
   keeping — CSS can't tell the dt rows apart, so tag them here. Runs
   on the class flip the cart code makes when the popup opens (the
   product markup is re-rendered on every add). */
(function () {
  var notification = document.getElementById('cart-notification');
  if (!notification) return;
  function tagRows() {
    notification.querySelectorAll('.product-option').forEach(function (row) {
      if (row.classList.contains('psna-opt-save') || row.classList.contains('psna-opt-spec')) return;
      var dt = row.querySelector('dt');
      var isSave = dt && /save|retail/i.test(dt.textContent);
      row.classList.add(isSave ? 'psna-opt-save' : 'psna-opt-spec');
    });
  }
  new MutationObserver(tagRows).observe(notification, { attributes: true, attributeFilter: ['class'] });
  tagRows();
})();

/* Sticky mobile add-to-cart.
   Phones coming from social/SidelineSwap land on product pages; once the
   real add-to-cart scrolls out of view a slim bottom bar takes over. The
   bar's button just clicks the real submit, so quantity (bundle picker
   included), validation, and the cart notification all behave exactly as
   if the shopper used the form. Mobile only (<750px); while shown it
   replaces the bundle strip to keep one bar at the bottom. */
(function () {
  var submit = document.querySelector('.product-form__submit');
  var anchor = document.querySelector('.product-form__buttons');
  if (!submit || !anchor || submit.disabled) return;

  var priceEl = document.querySelector('.product__info-container .price__sale .price-item--last');
  if (!priceEl || !priceEl.textContent.trim()) {
    priceEl = document.querySelector('.product__info-container .price__regular .price-item--regular');
  }
  var titleEl = document.querySelector('.product__title h1, h1.product__title, .product__title');

  var bar = document.createElement('div');
  bar.className = 'psna-satc';
  bar.innerHTML =
    '<div class="psna-satc__info">' +
    '<span class="psna-satc__title"></span>' +
    '<span class="psna-satc__price"></span>' +
    '</div>' +
    '<button type="button" class="button psna-satc__btn"></button>';
  bar.querySelector('.psna-satc__title').textContent = titleEl ? titleEl.textContent.trim() : '';
  bar.querySelector('.psna-satc__price').textContent = priceEl ? priceEl.textContent.trim() : '';
  bar.querySelector('.psna-satc__btn').textContent = submit.textContent.trim() || 'Add to cart';
  bar.querySelector('.psna-satc__btn').addEventListener('click', function () {
    submit.click();
  });
  document.body.appendChild(bar);

  var mobile = window.matchMedia('(max-width: 749px)');
  new IntersectionObserver(function (entries) {
    var e = entries[0];
    var passed = !e.isIntersecting && e.boundingClientRect.top < 0;
    var show = passed && mobile.matches;
    bar.classList.toggle('psna-satc--show', show);
    document.body.classList.toggle('psna-satc-open', show);
  }).observe(anchor);
})();

/* Drop-alert slide-in.
   The highest-converting email surface we can ship from the repo: a small
   delayed card (9s or 45% scroll) posting Shopify's native customer form
   with the same tags the sold-out drop signup writes. Suppression:
   subscribing silences it forever, dismissing snoozes it 14 days. Debug:
   ?psna-sub-now=1 shows it immediately. Success round-trips back to the
   same page with #psna-subscribed, which we turn into a toast. */
(function () {
  var LS;
  try {
    LS = window.localStorage;
    LS.getItem('psna');
  } catch (e) {
    return;
  }
  var FORCE = new URLSearchParams(window.location.search).has('psna-sub-now');

  if (window.location.hash === '#psna-subscribed') {
    LS.setItem('psnaSubscribed', '1');
    var toast = document.createElement('div');
    toast.className = 'psna-sub-toast';
    toast.setAttribute('role', 'status');
    toast.textContent = "Thanks! You're on the list.";
    document.body.appendChild(toast);
    setTimeout(function () { toast.remove(); }, 5000);
    return;
  }

  if (!FORCE) {
    if (LS.getItem('psnaSubscribed')) return;
    if (Date.now() < parseInt(LS.getItem('psnaSubSnooze') || '0', 10)) return;
  }

  var shown = false;
  function show() {
    if (shown) return;
    shown = true;
    var card = document.createElement('aside');
    card.className = 'psna-sub';
    card.setAttribute('role', 'dialog');
    card.setAttribute('aria-label', 'Mailing list signup');
    card.innerHTML =
      '<button type="button" class="psna-sub__close" aria-label="Dismiss">&times;</button>' +
      '<div class="psna-eyebrow">Mailing List</div>' +
      '<h3 class="psna-sub__heading">Join Ozzy&rsquo;s mailing list.</h3>' +
      '<p class="psna-sub__text">Stay up to date on our latest news and inventory drops.</p>' +
      '<form method="post" action="/contact#psna-subscribed" class="psna-sub__form">' +
      '<input type="hidden" name="form_type" value="customer">' +
      '<input type="hidden" name="utf8" value="✓">' +
      '<input type="hidden" name="contact[tags]" value="newsletter, restock-alerts">' +
      '<input type="hidden" name="return_to" value="' + window.location.pathname + '#psna-subscribed">' +
      '<input type="email" name="contact[email]" placeholder="you@email.com" aria-label="Email address" autocomplete="email" autocapitalize="off" autocorrect="off" required>' +
      '<button type="submit" class="psna-btn psna-btn-primary">Sign Up</button>' +
      '</form>' +
      '<button type="button" class="psna-sub__later">No thanks</button>';
    document.body.appendChild(card);

    function dismiss() {
      LS.setItem('psnaSubSnooze', String(Date.now() + 14 * 86400000));
      card.remove();
    }
    card.querySelector('.psna-sub__close').addEventListener('click', dismiss);
    card.querySelector('.psna-sub__later').addEventListener('click', dismiss);
  }

  if (FORCE) {
    show();
    return;
  }
  setTimeout(show, 9000);
  window.addEventListener('scroll', function onScroll() {
    var max = document.documentElement.scrollHeight - window.innerHeight;
    if (max > 0 && window.scrollY / max > 0.45) {
      window.removeEventListener('scroll', onScroll);
      show();
    }
  }, { passive: true });
})();

/* PSNA_REVIEWS: rotating review strip under the homepage hero.
   Hand-curated because every lot is a one-off — per-product widgets
   would sit at zero forever, so the site tells one shop-wide trust
   story instead. Paste real quotes from the Judge.me dashboard into
   REVIEWS as they arrive (trim to ~90 chars; verified buyers only)
   and flip LIVE once there are at least three. Preview the styling
   any time with ?psna-reviews=1 — that mode shows the clearly-marked
   SAMPLE copy below and never renders for normal visitors. */
(function () {
  var CFG = {
    LIVE: false,
    REVIEWS: [
      /* { q: 'Quote text', a: 'First L.' } */
    ],
    SAMPLE: [
      { q: 'Sample review — stick arrived exactly as graded, better than the photos.', a: 'Preview Only' },
      { q: 'Sample review — shipped same day, taped up by the weekend.', a: 'Preview Only' },
      { q: 'Sample review — real pro stock at half what my shop wanted.', a: 'Preview Only' }
    ]
  };
  var preview = new URLSearchParams(window.location.search).has('psna-reviews');
  var reviews = CFG.LIVE && CFG.REVIEWS.length ? CFG.REVIEWS : (preview ? CFG.SAMPLE : []);
  if (!reviews.length) return;
  var hero = document.querySelector('.psna-hero');
  if (!hero) return;
  var section = hero.closest('.shopify-section') || hero;
  var strip = document.createElement('aside');
  strip.className = 'psna-reviews';
  strip.setAttribute('aria-label', 'Customer reviews');
  strip.innerHTML =
    '<div class="psna-reviews__inner">' +
    '<span class="psna-reviews__stars" aria-hidden="true">&#9733;&#9733;&#9733;&#9733;&#9733;</span>' +
    '<span class="psna-reviews__quote"></span>' +
    '<span class="psna-reviews__author"></span>' +
    '</div>';
  section.parentNode.insertBefore(strip, section.nextSibling);
  var qEl = strip.querySelector('.psna-reviews__quote');
  var aEl = strip.querySelector('.psna-reviews__author');
  function set(idx) {
    qEl.textContent = '“' + reviews[idx].q + '”';
    aEl.textContent = '— ' + reviews[idx].a;
  }
  set(0);
  if (reviews.length > 1) {
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var i = 0;
    setInterval(function () {
      i = (i + 1) % reviews.length;
      if (reduce) { set(i); return; }
      strip.classList.add('psna-reviews--out');
      setTimeout(function () {
        set(i);
        strip.classList.remove('psna-reviews--out');
      }, 280);
    }, 7000);
  }
})();

/* Hand-first hero buttons.
   The buyer's first decision is which hand they shoot, so the hero
   actions become SHOOT LEFT / SHOOT RIGHT (native tag-filter URLs) with
   a quiet browse-all fallback. The old How-Pro-Stock-Works ghost button
   is retired. Rewritten client-side because the hero's button settings
   live in the section/template layer the GitHub sync skips. */
(function () {
  return; /* off: uses the hero's own buttons, set in Customize */
  var actions = document.querySelector('.psna-hero-actions');
  if (!actions || actions.dataset.psnaHand) return;
  actions.dataset.psnaHand = '1';
  actions.innerHTML =
    '<a href="/collections/prostock-sticks/lh" class="psna-btn psna-btn-primary">Shoot Left</a>' +
    '<a href="/collections/prostock-sticks/rh" class="psna-btn psna-btn-primary">Shoot Right</a>' +
    '<a href="/collections/prostock-sticks" class="psna-hero-browse-all">Browse all sticks &rarr;</a>';
})();

/* Homepage trust strip.
   Sits right after the Just Landed grid — answers "is this legit / why
   so cheap" at the moment of first product contact. Bridge-injected
   because homepage sections are stuck behind the GitHub sync issue. */
(function () {
  return; /* off: the strip's claims are PSNA's (US duties, stick bundles) */
  if (document.querySelector('.psna-trust')) return;
  var headings = document.querySelectorAll('main .shopify-section h2');
  var landed = Array.prototype.find.call(headings, function (h) {
    return /just landed/i.test(h.textContent);
  });
  if (!landed) return;
  var section = landed.closest('.shopify-section');
  if (!section) return;
  var strip = document.createElement('div');
  strip.className = 'psna-trust';
  strip.innerHTML =
    '<div class="psna-trust__inner">' +
    '<span>Duties included to the US</span>' +
    '<span>Bundle 2+ sticks &amp; save</span>' +
    '<span>Shop Pay express checkout</span>' +
    '<span>Fast, tracked shipping</span>' +
    '</div>';
  section.parentNode.insertBefore(strip, section.nextSibling);
})();

/* Last-unit scarcity copy.
   The server copy lives in a template block setting (templates/product.json
   -> psna_specs block), which the broken GitHub sync can't update from the
   repo. Bridge: rewrite the one-left line client-side. Remove this once the
   sync is fixed and the block's scarcity_text_one is updated server-side. */
(function () {
  return; /* off: PSNA lot wording */
  var el = document.querySelector('.psna-scarcity');
  if (!el) return;
  el.childNodes.forEach(function (node) {
    if (node.nodeType === 3 && /one of one/i.test(node.textContent)) {
      node.textContent = " Last one from this lot. When it sells, it's gone for good.";
    }
  });
})();

/* PSNA_SEO_SCHEMA - keep the product JSON-LD name in step with the composed
   <title>. Dawn renders {{ product | structured_data }} inside
   sections/main-product.liquid, which the GitHub sync skips, so the
   ProductGroup name would otherwise stay the short admin title ("TRUE HZRDUS
   9X4") that six different sticks share. og:title already carries the full
   spec title from snippets/psna-seo-title.liquid; mirror it into the schema.
   Google evaluates JSON-LD after scripts run. Visible markup is untouched. */
(function () {
  try {
    if (!/\/products\//.test(location.pathname)) return;
    var meta = document.querySelector('meta[property="og:title"]');
    var name = meta && meta.content ? meta.content.trim() : '';
    if (!name) return;
    var scripts = document.querySelectorAll('script[type="application/ld+json"]');
    Array.prototype.forEach.call(scripts, function (s) {
      var data;
      try { data = JSON.parse(s.textContent); } catch (e) { return; }
      var list = Array.isArray(data) ? data : [data];
      var changed = false;
      list.forEach(function (o) {
        if (!o || typeof o !== 'object') return;
        if (o['@type'] !== 'ProductGroup' && o['@type'] !== 'Product') return;
        if (o.name !== name) { o.name = name; changed = true; }
        if (Array.isArray(o.hasVariant)) {
          o.hasVariant.forEach(function (v) {
            if (v && typeof v === 'object' && v.name !== name) { v.name = name; changed = true; }
          });
        }
      });
      if (changed) s.textContent = JSON.stringify(Array.isArray(data) ? list : list[0]);
    });
  } catch (e) { /* schema patch is best-effort */ }
})();
